export default __webpack_public_path__ + "static/media/settings-icon.6edb0a06.svg";